import { useNavigate } from "react-router-dom";
import { useState } from "react";
import APIService from "../../services/Api";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { classNames } from "src/helpers/mixins";
import { ImSpinner9 } from "react-icons/im";
import { MdArrowRightAlt, MdError } from "react-icons/md";
import { FaArrowAltCircleRight } from "react-icons/fa";
import { BsCashStack } from "react-icons/bs";
import { useAppStateContext } from "src/auth/AppStateContext";
import { IoIosArrowDroprightCircle } from "react-icons/io";

type RegisterFormParams = {
  disableImage?: boolean;
  disabledBackground?: boolean;
};
const RegisterForm = ({
  disableImage,
  disabledBackground,
}: RegisterFormParams) => {
  const [response, setResponse] = useState<string>("");
  const [cashierApodo, setCashierApodo] = useState<string>("");
  const { setShowRegisterPopup } = useAppStateContext();
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  const onChangeCode = (e: React.FormEvent<HTMLInputElement>) => {
    const { value } = e.currentTarget;
    setCashierApodo(value.trim());
  };
  const verifyCode = async () => {
    setLoading(true);
    let cc = cashierApodo.trim();
    if (!cc.includes("-") && cc.length === 6) {
      cc = cc.substring(0, 3) + "-" + cc.substring(3, cc.length);
    }
    const res = await APIService.systemVerifyCashierApodo({ apodo: cc });
    setResponse(res?.data?.data?.registerlink);
    if (res?.data?.data?.registerlink !== "notfound") {
      setShowRegisterPopup(false);
      navigate(`/${cc}`);
    }
    setLoading(false);
  };
  const handleGoRegister = (url: string) => {
    setShowRegisterPopup(false);
    navigate(url);
  };

  return (
    <section>
      <ToastContainer
        position="bottom-center"
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className="grid lg:grid-cols-3 grid-cols-1  gap-0 flex flex-wrap ">
        {!disableImage && (
          <div className="bg-register col-span-1 hidden lg:block"></div>
        )}

        <div
          className={classNames("", disableImage ? "col-span-3" : "col-span-2")}
        >
          <section
            className={classNames(
              disabledBackground ? "" : "body-register-container",
              "px-2 md:px-4 bg-gradient-blue"
            )}
          >
            <div className="grid grid-cols-1 md:grid-cols-2  py-10 gap-6 ">
              <div>
                <div className="py-2 font-medium px-4 flex items-center justify-center fadeintop bg-yellow-400 rounded-md w-fit text-xl md:text-2xl border-b border-neutral-300 mb-4 opensans">
                  Unirse como cliente
                </div>
                {!loading ? (
                  <div className="fadeinbottom">
                    <div className="mt-2 border-b border-dashed mb-4 border-stone-400 pt-2 pb-2 font-medium text-lg opensans">
                      ¿No conoces el apodo de algún cajero?
                      <div className="text-xs">
                        Puedes registrarte y después seleccionar un cajero.
                      </div>
                      <div
                        className="bg-stone-200 w-fit fadeinbottom px-2 border-b-2 border border-stone-300 cursor-pointer text-black text-sm flex items-center gap-1 font-bold rounded-md px-2 py-2 mt-2"
                        onClick={() => handleGoRegister("/registro-usuario")}
                      >
                        <IoIosArrowDroprightCircle size={23} /> Continuar
                      </div>
                    </div>
                    <div className="font-medium  w-fit  py-2 text-sm rounded-md text-black text-xl opensans fadein">
                      ¿Conoces el apodo del cajero?
                    </div>
                    <div className="font-medium opensans text-sm mt-2 mb-2 text-black">
                      Escribe el apodo del cajero para registrarte.
                    </div>
                    <div className="flex flex-wrap items-center gap-1">
                      <input
                        type="text"
                        value={cashierApodo}
                        placeholder="escribir.. "
                        onChange={onChangeCode}
                        className="border border-neutral-400 shadow-md px-2 py-2 rounded-md font-medium bg-white w-full md:w-1/2"
                      />
                      <button
                        onClick={() => verifyCode()}
                        className="bg-yellow-400 fadeinbottom border-b-2 border-amber-500 text-black text-sm font-medium rounded-lg px-6 py-2"
                      >
                        Continuar
                      </button>
                    </div>
                    <div>
                      {response === "notfound" && (
                        <>
                          <div className="mt-2 font-medium w-fit border bg-red-300 px-2  py-2 rounded-md text-sm text-black flex items-center gap-2 ">
                            El código ingresado no fue encontrado.{" "}
                            <MdError className="text-red-700" size={22} />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="mt-8 pt-10 font-medium flex text-base items-center gap-2 fadein border-t border-neutral-500 border-dashed">
                    Estamos verificando el código.
                    <ImSpinner9
                      className="animate-spin text-rose-400"
                      size={35}
                    />
                  </div>
                )}
              </div>

              <div className="md:border-l md:border-gray-400 md:pl-4 border-dashed">
                <div className="mt-4 fadeintop text-2xl border-b border-neutral-300 mb-6 font-bold opensans pb-2">
                  Unirse como Cajero
                </div>
                <div className="font-medium text-base">
                  <div>Registra tus porcentajes de ganancias.</div>
                  <div className="mt-2">
                    elige los bancos y wallets de pago con los que deseas
                    trabajar.
                  </div>
                  <div className="mt-2">
                    Obtén tu propio dashboard de operaciones.
                  </div>
                </div>
                <button
                  onClick={() => handleGoRegister("/registro-cajero")}
                  className="bg-green-admin-light flex items-center gap-2 fadeinbottom border-b-2   text-white text-base font-normal rounded-xl px-4 py-2 mt-2"
                >
                  Registrarme como cajero <BsCashStack size={20} />
                </button>
              </div>
            </div>
          </section>
        </div>
      </div>
    </section>
  );
};

export default RegisterForm;
